(function() {
  'use strict';
  
  // Configuration
  const VISIBLE_ITEMS = 3.5;
  const SWATCH_IMAGE_SIZE = 120; // Fixed size for screens > 999px
  const BLOCK_SELECTOR = '.po-stack.po-col-span-12.po-stack--vertical';
  const CONTAINER_SELECTOR = '.po-option--container.po-option--type-swatch__inline';
  const MAX_RETRIES = 5;
  const RETRY_DELAY = 1000; // 1 second
  
  // Global flag to prevent any duplicate initialization
  const CAROUSEL_INIT_KEY = 'po-carousel-initialized';
  if (window[CAROUSEL_INIT_KEY]) {
    console.log('Carousel already initialized (global flag)');
    return;
  }
  
  let retryCount = 0;
  let initInProgress = false;
  
  function extractAndAddPrices(container) {
    const swatchWrappers = container.querySelectorAll('.po-option--swatch-wrapper');
    
    swatchWrappers.forEach(wrapper => {
      const tooltipPrice = wrapper.querySelector('.tooltip-swatch-label .po_option_value');
      const label = wrapper.querySelector('.po-option__swatch-label');
      
      if (tooltipPrice && label) {
        const fullText = tooltipPrice.textContent.trim();
        const priceMatch = fullText.match(/\(\+\$[\d,]+\.?\d*\)/);
        
        if (priceMatch) {
          const priceWithParens = priceMatch[0];
          const priceWithoutParens = priceWithParens.replace(/[()]/g, '');
          
          if (!label.querySelector('.po-option__price')) {
            const priceSpan = document.createElement('span');
            priceSpan.className = 'po-option__price';
            priceSpan.textContent = priceWithoutParens;
            
            label.appendChild(document.createElement('br'));
            label.appendChild(priceSpan);
            
            console.log(`Added price ${priceWithoutParens} to ${label.textContent.trim()}`);
          }
        }
      }
    });
  }
  
  function isDesktop() {
    return window.innerWidth > 999;
  }
  
  function initCarouselForContainer(container, blockIndex) {
    // Check if carousel already exists
    if (container.closest('.po-carousel-wrapper')) {
      console.log(`Block ${blockIndex}: Carousel wrapper already exists`);
      return;
    }
    
    // Check if already being processed
    if (container.hasAttribute('data-carousel-processing')) {
      console.log(`Block ${blockIndex}: Container already being processed`);
      return;
    }
    
    const items = container.querySelectorAll('.po-option--swatch-wrapper');
    
    if (!items || items.length === 0) {
      console.log(`Block ${blockIndex}: No items found`);
      return;
    }
    
    // Extract and add prices
    extractAndAddPrices(container);
    
    // If 3 or fewer items, no carousel needed
    if (items.length <= 3) {
      console.log(`Block ${blockIndex}: Only ${items.length} items - carousel not needed`);
      return;
    }
    
    console.log(`Block ${blockIndex}: Initializing carousel with ${items.length} items`);
    
    // Mark as processing
    container.setAttribute('data-carousel-processing', 'true');
    
    let currentIndex = 0;
    
    // Wrap container in carousel wrapper
    const carouselWrapper = document.createElement('div');
    carouselWrapper.className = 'po-carousel-wrapper';
    carouselWrapper.setAttribute('data-carousel-initialized', 'true');
    carouselWrapper.setAttribute('data-block-index', blockIndex);
    container.parentNode.insertBefore(carouselWrapper, container);
    
    // Create inner track
    const track = document.createElement('div');
    track.className = 'po-carousel-track';
    carouselWrapper.appendChild(track);
    track.appendChild(container);
    
    // Add carousel controls
    const controls = document.createElement('div');
    controls.className = 'po-carousel-controls';
    controls.innerHTML = `
      <button type="button" class="po-carousel-btn po-carousel-prev" aria-label="Previous">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20" height="20" width="20">
        <path stroke-linejoin="round" stroke-linecap="round" stroke-width="2" stroke="#B44531" d="M11.6663 5L16.6663 9.99998L11.6663 15M15.833 9.99998H3.33301"/>
        </svg>
      </button>
      <button type="button" class="po-carousel-btn po-carousel-next" aria-label="Next">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20" height="20" width="20">
<path stroke-linejoin="round" stroke-linecap="round" stroke-width="2" stroke="#B44531" d="M11.6663 5L16.6663 9.99998L11.6663 15M15.833 9.99998H3.33301"/>
</svg>
      </button>
    `;
    carouselWrapper.appendChild(controls);
    
    const prevBtn = controls.querySelector('.po-carousel-prev');
    const nextBtn = controls.querySelector('.po-carousel-next');
    
    // Calculate dimensions
    function getGap() {
      const containerStyle = window.getComputedStyle(container);
      return parseFloat(containerStyle.gap) || 15;
    }
    
    function getTrackWidth() {
      return track.offsetWidth;
    }
    
    function calculateItemWidth() {
      if (isDesktop()) {
        const itemWidth = SWATCH_IMAGE_SIZE;
        
        items.forEach(item => {
          item.style.width = `${itemWidth}px`;
          item.style.minWidth = `${itemWidth}px`;
          item.style.maxWidth = `${itemWidth}px`;
        });
        
        return itemWidth;
      } else {
        const trackWidth = getTrackWidth();
        const gap = getGap();
        const totalGaps = (VISIBLE_ITEMS - 1) * gap;
        const itemWidth = (trackWidth - totalGaps) / VISIBLE_ITEMS;
        
        items.forEach(item => {
          item.style.width = `${itemWidth}px`;
          item.style.minWidth = `${itemWidth}px`;
          item.style.maxWidth = `${itemWidth}px`;
        });
        
        return itemWidth;
      }
    }
    
    // Update carousel position
    function updateCarousel(smooth = true) {
      const itemWidth = calculateItemWidth();
      const gap = getGap();
      const moveDistance = itemWidth + gap;
      const offset = -(currentIndex * moveDistance);
      
      container.style.transition = smooth ? 'transform 0.3s ease-in-out' : 'none';
      container.style.transform = `translateX(${offset}px)`;
      
      updateButtons();
    }
    
    // Update button states
    function updateButtons() {
      const maxIndex = items.length - Math.floor(VISIBLE_ITEMS);
      prevBtn.disabled = currentIndex <= 0;
      nextBtn.disabled = currentIndex >= maxIndex;
    }
    
    // Navigation handlers
    function goToPrev(e) {
      e.preventDefault();
      e.stopPropagation();
      if (currentIndex > 0) {
        currentIndex--;
        updateCarousel();
      }
    }
    
    function goToNext(e) {
      e.preventDefault();
      e.stopPropagation();
      const maxIndex = items.length - Math.floor(VISIBLE_ITEMS);
      if (currentIndex < maxIndex) {
        currentIndex++;
        updateCarousel();
      }
    }
    
    // Event listeners
    prevBtn.addEventListener('click', goToPrev);
    nextBtn.addEventListener('click', goToNext);
    
    // Handle window resize
    let resizeTimeout;
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(function() {
        updateCarousel(false);
      }, 250);
    });
    
    // Initialize
    updateCarousel(false);
    
    console.log(`Block ${blockIndex}: Carousel initialized successfully`);
    
    // Verify after 1 second
    setTimeout(function() {
      if (track.offsetWidth > 0 && items[0].offsetWidth > 0) {
        console.log(`Block ${blockIndex}: Carousel verification passed`);
        updateCarousel(false);
      } else {
        console.warn(`Block ${blockIndex}: Carousel verification failed`);
      }
    }, 1000);
  }
  
  function initAllCarousels() {
    if (initInProgress) {
      console.log('Carousel init already in progress, skipping...');
      return;
    }
    
    initInProgress = true;
    
    const blocks = document.querySelectorAll(BLOCK_SELECTOR);
    
    if (!blocks || blocks.length === 0) {
      if (retryCount < MAX_RETRIES) {
        retryCount++;
        console.log(`Init attempt ${retryCount}/${MAX_RETRIES} - blocks not found, retrying...`);
        initInProgress = false;
        setTimeout(initAllCarousels, RETRY_DELAY);
      } else {
        console.log('Init failed - blocks not found after max retries');
        initInProgress = false;
        window[CAROUSEL_INIT_KEY] = true;
      }
      return;
    }
    
    console.log(`Found ${blocks.length} blocks to check`);
    
    blocks.forEach((block, index) => {
      const container = block.querySelector(CONTAINER_SELECTOR);
      
      if (container) {
        initCarouselForContainer(container, index + 1);
      } else {
        console.log(`Block ${index + 1}: No container found`);
      }
    });
    
    // Add styles once
    addCarouselStyles();
    
    window[CAROUSEL_INIT_KEY] = true;
    initInProgress = false;
    console.log('All carousels initialized');
  }
  
  function addCarouselStyles() {
    if (document.getElementById('po-carousel-styles')) return;
    
    const style = document.createElement('style');
    style.id = 'po-carousel-styles';
    style.textContent = `
      .po-carousel-wrapper {
        position: relative;
        padding-top: 50px;
      }
      
      .po-carousel-track {
        overflow: hidden;
        width: 100%;
      }
      
      .po-option--container.po-option--type-swatch__inline {
        display: flex !important;
        flex-wrap: nowrap !important;
        gap: 12px;
        width: max-content;
      }
      
      .po-option--swatch-wrapper {
        flex: 0 0 auto;
      }
      
      @media (min-width: 1000px) {
        .po-option--swatch-wrapper .po-option__swatch-media {
          width: ${SWATCH_IMAGE_SIZE}px !important;
          height: ${SWATCH_IMAGE_SIZE}px !important;
        }
        
        .po-option--swatch-wrapper .po-option__image-value {
          width: ${SWATCH_IMAGE_SIZE}px !important;
          height: ${SWATCH_IMAGE_SIZE}px !important;
        }
      }
      
      .po-option__swatch-label {
        display: block;
      }
      
      .po-option__price {
        display: block;
        font-size: 0.9em;
        color: #666;
        margin-top: 4px;
      }
      
      .po-carousel-controls {
        position: absolute;
        top: 0;
        right: 0;
        display: flex;
        gap: 8px;
        z-index: 10;
      }
      
     
      @media (max-width: 999px) {
        .po-carousel-wrapper {
          padding-top: 45px;
        }
        
        
      }
    `;
    document.head.appendChild(style);
  }
  
  // Start initialization after 1 second
  setTimeout(function() {
    console.log('Starting carousel initialization...');
    initAllCarousels();
  }, 1000);
  
})();